var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16.014px",
    viewBox: "78.425 139.781 16 16.014",
    enableBackground: "new 78.425 139.781 16 16.014",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M93.634,145.206l0.086-0.117l-7.299-5.308l-6.996,5.212v-0.124c0,0-1,0.668-1,1.49v7.945 c0,0.822,0.673,1.49,1.5,1.49h13c0.827,0,1.5-0.668,1.5-1.49v-7.945C94.425,145.891,94.097,145.479,93.634,145.206z  M93.425,146.359v7.93l-4.786-3.111l4.751-5.056C93.421,146.192,93.425,146.272,93.425,146.359z M79.425,146.342l4.586,4.88 l-4.586,2.796V146.342z M86.417,150.92l5.971,3.882H80.052L86.417,150.92z M86.429,141.017l5.996,4.36v0.315l-4.635,4.933 l-1.356-0.882l-1.554,0.947l-4.71-5.012L86.429,141.017z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail01);
export default __webpack_public_path__ + "static/media/icon_email-01.4ad98efa7b8292827f87e0b6c7b26a10.svg";
export { ForwardRef as ReactComponent };